<template>
  <div>
    <template v-if="params.data.tableName != 'InventoryStockDetail'">
    <feather-icon icon="Edit3Icon" title="Düzenleme" svgClasses="h-5 w-5 mr-5 hover:text-primary cursor-pointer" @click="editRecord" v-if="editDeleteAvailable()" />
    <feather-icon icon="SearchIcon" title="Detay" svgClasses="h-5 w-5 mr-5 hover:text-primary cursor-pointer" @click="showRecord" />
    </template>

    <feather-icon icon="CheckCircleIcon" title="Onaylama" svgClasses="h-5 mr-5 hover:text-danger cursor-pointer" @click="changeFormStatus('O','Form onaylanacaktır.')" v-if="approveAvailable()" />
    <feather-icon icon="XIcon" title="Reddet" svgClasses="h-5 mr-5 hover:text-danger cursor-pointer" @click="changeFormStatus('R','Form reddedilecektir')" v-if="approveAvailable()" />


    <!-- <feather-icon icon="TrashIcon" title="Onaylama" svgClasses="h-5 mr-5 hover:text-danger cursor-pointer" @click="invokeParentMethod()" /> -->
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";

export default {
  data() {
    return {
      visible: false,
      popupOwnCost: false,
      visibleForApprove: false,
    };
  },
  name: "CellRendererActions",
  methods: {
    editRecord() {
      if (this.params.data.tableName == "Permission") {
        this.$router.push("../permissionedit/" + this.params.data.formId);
      }
      if (this.params.data.tableName == "Advance") {
        this.$router.push("../advanceEdit/" + this.params.data.formId);
      }
    },

    showRecord() {
      if (this.params.data.tableName == "Permission") {
        this.$router.push("../permissionview/" + this.params.data.formId);
      }
      if (this.params.data.tableName == "Advance") {
        this.$router.push("../advanceView/" + this.params.data.formId);
      }
    },

    editDeleteAvailable() {
      if (this.params.data.status == "T" && this.params.data.formOwnerId == this.$store.state.userData.userId) {
        return true;
      } else {
        return false;
      }
    },

    approveAvailable() {
      if (this.params.data.status == "T" && this.params.data.managerUserId == this.$store.state.userData.userId) {
        return true;
      } else {
        return false;
      }
    },

    // invokeParentMethod: async function() {
    //   // this.params.context.componentParent.getHRManagementList();
    //   console.log(this.params.context);
    //   this.params.context.componentParent.methodFromParent();
    // },

    changeFormStatus: async function(status, messageText) {
      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();

      await repository.postEntity("HumanResource/changeFormStatus", { status: status, formId: this.params.data.formId, tableName: this.params.data.tableName, firstApproverId: this.$store.state.userData.userId });

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.params.context.componentParent.getHRManagementList();
    },
  },

  computed: {},
};
</script>
